"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DatePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _dateFns = require("date-fns");

var _es = _interopRequireDefault(require("date-fns/locale/es"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _TimePicker = _interopRequireDefault(require("../TimePicker/TimePicker"));

var _classNames2 = _interopRequireDefault(require("../../util/classNames"));

require("../../styles/DatePickerInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var locales = {
  es: {
    locale: _es["default"],
    format: "d 'de' MMM",
    formatWithTime: "d 'de' MMM, HH:mm",
    formatWithYear: "d 'de' MMM 'de' yyyy",
    formatWithYearAndTime: "d 'de' MMM 'de' yyyy, HH:mm"
  },
  en: {
    locale: _enUS["default"],
    format: 'MMM d',
    formatWithTime: 'MMM d, HH:mm',
    formatWithYear: 'MMM d, yyyy',
    formatWithYearAndTime: 'MMM d yyyy, HH:mm'
  },
  pt: {
    locale: _ptBR["default"],
    format: "d 'de' MMM",
    formatWithTime: "d 'de' MMM, HH:mm",
    formatWithYear: "d 'de' MMM 'de' yyyy",
    formatWithYearAndTime: "d 'de' MMM 'de' yyyy, HH:mm"
  }
};

var formatToStringHelper = function formatToStringHelper(date, withTime, lang) {
  return (0, _dateFns.isThisYear)(date) ? formatToString(date, withTime, lang) : formatToStringWithYear(date, withTime, lang);
};

var formatToString = function formatToString(date, withTime, lang) {
  return (0, _dateFns.format)(date, withTime ? locales[lang].formatWithTime : locales[lang].format, {
    locale: locales[lang].locale
  });
};

var formatToStringWithYear = function formatToStringWithYear(date, withTime, lang) {
  return (0, _dateFns.format)(date, withTime ? locales[lang].formatWithYearAndTime : locales[lang].formatWithYear, {
    locale: locales[lang].locale
  });
};

var DatePicker = function DatePicker(_ref) {
  var startDate = _ref.startDate,
      setStartDate = _ref.setStartDate,
      selectRange = _ref.selectRange,
      endDate = _ref.endDate,
      setEndDate = _ref.setEndDate,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      selectTime = _ref.selectTime,
      _ref$monthsShown = _ref.monthsShown,
      monthsShown = _ref$monthsShown === void 0 ? 2 : _ref$monthsShown,
      labels = _ref.labels,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? 'es' : _ref$lang;

  var setDate = function setDate(dates) {
    if (selectRange) {
      var _dates = _slicedToArray(dates, 2),
          start = _dates[0],
          end = _dates[1];

      setStartDate(start ? (0, _dateFns.startOfDay)(start) : start);
      setEndDate(end ? (0, _dateFns.endOfDay)(end) : end);
    } else {
      setStartDate(minDate ? (0, _dateFns.max)([minDate, dates]) : dates);
    }
  };

  var endDateHandler = function endDateHandler(date) {
    if (endDate == null) {
      //which means user hasn't explicitly selected an end date
      var newEnd = (0, _dateFns.set)(startDate, {
        hours: (0, _dateFns.getHours)(date),
        minutes: (0, _dateFns.getMinutes)(date)
      });
      if (newEnd < startDate) setEndDate(startDate);else setEndDate(newEnd);
    } else {
      setEndDate(date);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    inline: true,
    calendarClassName: "inline",
    locale: locales[lang].locale,
    monthsShown: monthsShown,
    selected: startDate,
    startDate: startDate,
    endDate: endDate,
    selectsRange: selectRange,
    minDate: minDate,
    maxDate: maxDate,
    onChange: setDate,
    formatWeekDay: function formatWeekDay(weekday) {
      return weekday.charAt(0).toUpperCase();
    }
  }, selectTime && /*#__PURE__*/_react["default"].createElement("div", {
    className: "datepicker-timepicker"
  }, /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
    label: labels.startTime,
    time: startDate,
    onChange: setStartDate,
    min: minDate,
    max: maxDate,
    lang: lang
  }), selectRange && /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
    label: labels.endTime,
    time: endDate,
    onChange: endDateHandler,
    min: startDate,
    max: maxDate,
    lang: lang
  })));
};

exports.DatePicker = DatePicker;

var DatePickerHolder = function DatePickerHolder(_ref2) {
  var _classNames;

  var startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      onClick = _ref2.onClick,
      className = _ref2.className,
      lang = _ref2.lang,
      connector = _ref2.connector,
      placeholder = _ref2.placeholder,
      withTime = _ref2.withTime;

  var dateLabel = function dateLabel() {
    if (startDate === null) return placeholder;
    if (endDate === null || (0, _dateFns.isSameDay)(startDate, endDate) && !withTime) return formatToStringHelper(startDate, withTime, lang);
    if ((0, _dateFns.isSameYear)(startDate, endDate)) return "".concat(formatToString(startDate, withTime, lang), " ").concat(connector, " ").concat(formatToStringHelper(endDate, withTime, lang));
    return "".concat(formatToStringWithYear(startDate, withTime, lang), " ").concat(connector, " ").concat(formatToStringWithYear(endDate, withTime, lang));
  };

  var classes = (0, _classNames2["default"])((_classNames = {}, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "empty", startDate === null), _classNames));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'sb-filter-toggle ' + classes,
    onClick: onClick
  }, dateLabel());
};

var DatePickerInput = function DatePickerInput(_ref3) {
  var startDate = _ref3.startDate,
      endDate = _ref3.endDate,
      setStartDate = _ref3.setStartDate,
      setEndDate = _ref3.setEndDate,
      maxDate = _ref3.maxDate,
      onClose = _ref3.onClose,
      selectTime = _ref3.selectTime,
      noButtons = _ref3.noButtons,
      _ref3$lang = _ref3.lang,
      lang = _ref3$lang === void 0 ? 'es' : _ref3$lang,
      labels = _ref3.labels,
      minDate = _ref3.minDate,
      error = _ref3.error,
      CustomInput = _ref3.CustomInput,
      commitRequired = _ref3.commitRequired,
      onCalendarClose = _ref3.onCalendarClose;
  var dpRef = (0, _react.useRef)(null);
  var disabledCommit = commitRequired && (error || endDate == null || startDate == null);

  var setDate = function setDate(dates) {
    var _dates2 = _slicedToArray(dates, 2),
        start = _dates2[0],
        end = _dates2[1];

    setStartDate(start ? (0, _dateFns.startOfDay)(start) : start);
    setEndDate(end ? (0, _dateFns.endOfDay)(end) : end);
  };

  var endDateHandler = function endDateHandler(date) {
    if (endDate == null) {
      //which means user hasn't explicitly selected an end date
      var newEnd = (0, _dateFns.set)(startDate || (0, _dateFns.startOfToday)(), {
        hours: (0, _dateFns.getHours)(date),
        minutes: (0, _dateFns.getMinutes)(date)
      });
      if (newEnd < startDate) setEndDate(startDate);else setEndDate(newEnd);
    } else {
      setEndDate(date);
    }
  };

  var clear = function clear() {
    setStartDate(null);
    setEndDate(null);
  };

  var close = function close() {
    dpRef.current.setOpen(false);
    onClose && onClose();
  };

  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    ref: dpRef,
    showPopperArrow: false,
    locale: locales[lang].locale,
    onCalendarClose: onCalendarClose,
    monthsShown: 2 // showPreviousMonths={startDate == null}
    ,
    customInput: CustomInput ? /*#__PURE__*/_react["default"].createElement(CustomInput, {
      startDate: startDate,
      endDate: endDate,
      lang: lang,
      label: labels.label,
      error: error,
      connector: labels.connector,
      withTime: selectTime
    }) : /*#__PURE__*/_react["default"].createElement(DatePickerHolder, {
      startDate: startDate,
      endDate: endDate,
      lang: lang,
      connector: labels.connector,
      withTime: selectTime
    }),
    selected: startDate,
    startDate: startDate,
    endDate: endDate,
    placeholderText: labels.placeholder // selectsStart={startDate === null}
    // selectsEnd={startDate !== null}
    ,
    selectsRange: true,
    shouldCloseOnSelect: false,
    maxDate: maxDate ? maxDate : (0, _dateFns.endOfToday)(),
    minDate: minDate ? minDate : undefined,
    onChange: setDate,
    formatWeekDay: function formatWeekDay(weekday) {
      return weekday.charAt(0).toUpperCase();
    },
    popperModifiers: {
      preventOverflow: {
        enabled: true
      }
    }
  }, selectTime && /*#__PURE__*/_react["default"].createElement("div", {
    className: "datepicker-timepicker ".concat(error ? 'datepicker-error_timepicker' : '')
  }, /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
    error: error,
    label: labels.startTime,
    time: startDate,
    onChange: setStartDate,
    lang: lang
  }), /*#__PURE__*/_react["default"].createElement(_TimePicker["default"], {
    error: error,
    label: labels.endTime,
    time: endDate,
    onChange: endDateHandler,
    min: startDate,
    max: maxDate ? maxDate : (0, _dateFns.endOfToday)(),
    lang: lang
  })), error && /*#__PURE__*/_react["default"].createElement("p", {
    className: "datepicker-error_label"
  }, labels.error), !noButtons && /*#__PURE__*/_react["default"].createElement("div", {
    className: "datepicker-footer"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: clear
  }, labels.clear), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: close,
    disabled: disabledCommit
  }, labels.save)));
};

DatePickerInput.propTypes = {
  startDate: _propTypes["default"].instanceOf(Date),
  endDate: _propTypes["default"].instanceOf(Date),
  setStartDate: _propTypes["default"].func,
  setEndDate: _propTypes["default"].func,
  maxDate: _propTypes["default"].instanceOf(Date),
  minDate: _propTypes["default"].instanceOf(Date),
  onClose: _propTypes["default"].func,
  selectTime: _propTypes["default"].bool,
  noButtons: _propTypes["default"].bool,
  lang: _propTypes["default"].string,
  CustomInput: _propTypes["default"].any,
  error: _propTypes["default"].any,
  commitRequired: _propTypes["default"].bool,
  labels: _propTypes["default"].shape({
    placeholder: _propTypes["default"].string,
    clear: _propTypes["default"].string,
    save: _propTypes["default"].string,
    connector: _propTypes["default"].string,
    startTime: _propTypes["default"].string,
    endTime: _propTypes["default"].string,
    label: _propTypes["default"].string,
    error: _propTypes["default"].string
  })
};
var _default = DatePickerInput;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/DatePickerInput/DatePickerInput.js
// module id = 1897
// module chunks = 0